import { InjectionToken } from '@angular/core';
import { IEnvironment } from '../_interfaces/IEnvironment';

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment');
export const API_URL = new InjectionToken<string>('apiUrl');
export const BRANCH_ID = new InjectionToken<string>('branchId');
export const NOTIFICATION = new InjectionToken<string>('notification');
